import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

type SliderProps = React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
  /** Inline styles for the track, e.g. a gradient background. */
  trackStyle?: React.CSSProperties
  /** Inline styles for the thumb, e.g. a value-dependent colour. */
  thumbStyle?: React.CSSProperties
  /** Hide the filled range (useful when the track itself carries a gradient). */
  hideRange?: boolean
}

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  SliderProps
>(({ className, trackStyle, thumbStyle, hideRange, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track
      className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary/20"
      style={trackStyle}
    >
      {!hideRange && !trackStyle && (
        <SliderPrimitive.Range className="absolute h-full bg-primary" />
      )}
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      className="block h-4 w-4 cursor-grab rounded-full border border-primary/50 bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:cursor-grabbing disabled:pointer-events-none disabled:opacity-50"
      style={thumbStyle}
    />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
